import { useState } from 'react';
import { RegistrationWizard } from '../registration/RegistrationWizard.js';
import { RegistrationComplete } from '../registration/RegistrationComplete.js';
import { guideSteps } from '../registration/guideSteps.js';
import { emptyRegFormData, type RegFormData } from '../registration/types.js';
import { submitRegistration } from '../registration/submit.js';

export function RegisterGuideView() {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [doneEmail, setDoneEmail] = useState<string | null>(null);

  async function onSubmit(data: RegFormData) {
    setError(null);
    setSubmitting(true);
    try {
      await submitRegistration('guide', data);
      setDoneEmail(data.email);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  if (doneEmail) return <RegistrationComplete email={doneEmail} role="guide" />;
  return (
    <RegistrationWizard heading="Deaf Guide registration" getSteps={() => guideSteps} initialData={emptyRegFormData()}
      submitting={submitting} error={error} onSubmit={onSubmit} submitLabel="Submit Application" />
  );
}
